import {
  Box,
  Button,
  Collapse,
  Flex,
  HStack,
  IconButton,
  Image,
  Stack,
  Text,
  useDisclosure,
  useMediaQuery,
} from '@chakra-ui/react';
import styled from '@emotion/styled';
import { Close, Menu } from '@mui/icons-material';
import CampaignIcon from '@mui/icons-material/Campaign';
import Link from 'next/link';

const PageContainer = styled.div`
  max-width: 1536px;
  margin: auto;
  height: 100%;
`;

type NavItem = {
  label: string;
  href: string;
};

const NAV_ITEMS: NavItem[] = [
  { label: 'Home', href: 'https://www.sukandaonelink.com/' },
  {
    label: 'Tentang Kami',
    href: 'https://www.sukandaonelink.com/#tentang-kami',
  },
  {
    label: 'Hubungi Kami',
    href: 'https://www.sukandaonelink.com/hubungi-kami',
  },
  { label: 'Resep Chef', href: '/recipes' },
  { label: 'Login', href: '/' },
];

export const PublicHeader = () => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const [isTablet] = useMediaQuery('(max-width: 992px)');

  return isMobile || isTablet ? <MobileHeader /> : <DesktopHeader />;
};

const DesktopHeader = () => {
  return (
    <Box position="sticky" top="0" zIndex="2">
      <Box bg="white" w="full" h="88px" px={{ base: 4, md: 8, lg: 12, xl: 16 }}>
        <PageContainer>
          <Flex
            w="100%"
            h="full"
            justifyContent="space-between"
            alignItems="center"
            gap={{ base: 'unset', md: 12 }}
          >
            <Box w="-webkit-max-content">
              <Link href="https://www.sukandaonelink.com/">
                <Image
                  src="/images/sukanda_logo_LR.png"
                  alt="SUKANDA ONELINK"
                  width="auto"
                  height="37.51px"
                  cursor="pointer"
                />
              </Link>
            </Box>
            <HStack spacing="10">
              {NAV_ITEMS.map((item) => (
                <Text
                  as={Link}
                  key={item.href}
                  href={item.href}
                  color="#6E7191"
                  fontWeight="medium"
                  fontSize="sm"
                  transition="color 0.2s ease-in-out"
                  _hover={{ color: '#EC161E' }}
                >
                  {item.label}
                </Text>
              ))}

              <Button
                bg="#3C64B1"
                h="42px"
                w="145px"
                fontWeight="medium"
                fontSize="sm"
              >
                Aktivasi
              </Button>
            </HStack>
          </Flex>
        </PageContainer>
      </Box>
      <Flex
        justifyContent="center"
        bg="orange"
        py="3"
        px={{ base: 4, md: 8, lg: 12, xl: 16 }}
      >
        <PageContainer>
          <Flex
            justifyContent="center"
            alignItems="center"
            color="white"
            gap="6px"
          >
            <CampaignIcon />
            <Text fontSize="sm">
              Akses 2000+ produk terbaik dari Sukanda Djaya!
            </Text>
            <Image
              src="/images/sukanda_logo_landscape.png"
              alt="SUKANDA ONELINK"
              width="auto"
              height="16px"
              cursor="pointer"
            />
          </Flex>
        </PageContainer>
      </Flex>
    </Box>
  );
};

const MobileHeader = () => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box position="sticky" top="0" zIndex="2" bg="white">
      <PageContainer>
        <Flex justify="space-between" align="center" p="2">
          <Link href="https://www.sukandaonelink.com/">
            <Image
              src="/images/sukanda_logo_LR.png"
              alt="SUKANDA ONELINK"
              w="auto"
              h="37.51px"
            />
          </Link>
          <IconButton
            aria-label="Toggle Menu"
            icon={isOpen ? <Close /> : <Menu />}
            onClick={onToggle}
            variant="ghost"
            position="relative"
            zIndex="4"
            _hover={{ bg: 'gray.100' }}
          />
        </Flex>
      </PageContainer>

      <Collapse in={isOpen} animateOpacity>
        <Box bg="white" p="4" boxShadow="lg">
          <Flex direction="column" align="start" gap="1">
            {NAV_ITEMS.map((item) => (
              <Text
                as={Link}
                key={item.href}
                href={item.href}
                color="#6E7191"
                fontWeight="medium"
                fontSize="sm"
                transition="color 0.2s"
                onClick={onToggle}
              >
                {item.label}
              </Text>
            ))}

            <Button
              bg="#3C64B1"
              h="42px"
              w="145px"
              fontWeight="medium"
              fontSize="sm"
              onClick={onToggle}
            >
              Aktivasi
            </Button>
          </Flex>
        </Box>
      </Collapse>

      <Box bg="orange" py="1" color="white" fontSize="sm">
        <PageContainer>
          <Stack gap="1" alignItems="center">
            <Flex align="center" gap="2">
              <CampaignIcon />
              <Text>Akses 2000+ produk terbaik dari Sukanda Djaya!</Text>
            </Flex>
            <Box>
              <Image
                src="/images/sukanda_logo_landscape.png"
                alt="SUKANDA ONELINK"
                w="auto"
                h="16px"
              />
            </Box>
          </Stack>
        </PageContainer>
      </Box>
    </Box>
  );
};
